import { CloseRounded } from '@mui/icons-material';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  ListItem,
  Slide,
  Stack,
  Typography,
} from '@mui/material';
import { variants } from '../../../../variants/variants';
import { rocket } from '../../assets/index';
import { colors } from '../../utility/status';
import CandidateOverview from '../Candidate/CandidateOverview';
import FeedbackRating from './FeedbackRating';
import { useMediaQuery } from '@mui/material';
import { forwardRef } from 'react';

const Transition = forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});
const ViewFeedback = ({ open, handleClose, interview }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={'md'}
      fullWidth
      fullScreen={isMobile}
      TransitionComponent={Transition}
    >
      <DialogTitle sx={{ borderBottom: 1, borderColor: 'divider', mb: 1, p: 1 }}>
        <Stack direction='row' alignItems={'center'}>
          <Typography>
            Candidate feedback form submitted by - <b>{interview?.member?.empName}</b>
          </Typography>
          <IconButton sx={{ ml: 'auto' }} {...(open && { className: 'backButton' })} onClick={handleClose}>
            <CloseRounded fontSize='small' />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 1.5 }}>
        <CandidateOverview formDetails={interview?.formDetails} />
        {/* positive points */}
        <FormControl
          component='fieldset'
          sx={{ borderRadius: variants.boxRadius.MAIN, border: 1, borderColor: 'divider', width: 1 }}
        >
          <FormLabel component='legend'>
            <Typography sx={{ fontSize: variants.BODY }}>Positive points</Typography>
          </FormLabel>
          {interview?.feedback?.positivePoints.map((item, index) => {
            return (
              <ListItem key={index} sx={{ p: 1 }}>
                <img src={rocket} style={{ width: 20, height: 20 }} />. {item}
              </ListItem>
            );
          })}
        </FormControl>

        {/* Areas of improvement */}
        <FormControl
          component='fieldset'
          sx={{ borderRadius: variants.boxRadius.MAIN, border: 1, borderColor: 'divider', width: 1, mt: 1 }}
        >
          <FormLabel component='legend'>
            <Typography sx={{ fontSize: variants.BODY }}>Areas of improvement</Typography>
          </FormLabel>
          {interview?.feedback?.areasOfImprovement.map((item, index) => {
            return (
              <ListItem key={index} sx={{ p: 1 }}>
                <img src={rocket} style={{ width: 20, height: 20 }} />. {item}
              </ListItem>
            );
          })}
        </FormControl>

        {/* Plan */}
        <FormControl
          component='fieldset'
          sx={{ borderRadius: variants.boxRadius.MAIN, border: 1, borderColor: 'divider', width: 1, mt: 1, p: 1 }}
        >
          <FormLabel component='legend'>
            <Typography sx={{ fontSize: variants.BODY }}>Plan</Typography>
          </FormLabel>
          <Typography sx={{ fontSize: variants.BODY }}>{interview?.feedback?.plan}</Typography>
        </FormControl>

        {/* rating */}
        <FeedbackRating rating={interview?.feedback?.rating} readOnly />
        {/* conclusion */}
        <Typography
          sx={{
            fontSize: variants.BODY,
            fontWeight: 600,
            mx: 'auto',
            mt: 2,
            width: 'max-content',
            color: interview?.feedback?.conclusion ? colors.Pass : colors.Fail,
          }}
        >
          The candidate {interview?.feedback?.conclusion ? 'qualifies' : 'does not qualify'} for the aspired role.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ViewFeedback;
